module.exports = __webpack_public_path__ + "static/media/liquid_110_detail.93e55e41.jpg";